import { Link } from 'react-router-dom';

const FRIEND_LINKS = ['影视资源导航', '美剧资讯站', '电影剧情库', '在线观影指南', '影迷社区'];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-white flex items-center justify-center">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-white">美国式禁忌4</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              专注《美国式禁忌4》高清影视资源、剧情介绍与影视资讯，为影迷提供清晰、舒适的观影与信息查询体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">网站导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-300 hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/category" className="text-background-300 hover:text-accent-400 transition-colors">影视分类</Link></li>
              <li><Link to="/news" className="text-background-300 hover:text-accent-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/about" className="text-background-300 hover:text-accent-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">友情链接</h4>
            <ul className="space-y-2.5 text-sm">
              {FRIEND_LINKS.map((link) => (
                <li key={link}>
                  <span className="text-background-300">{link}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@taboo4-demo.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-400"></i>
                <span>微信公众号：美国式禁忌4影视</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-accent-400"></i>
                <span>微博：@美国式禁忌4</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-background-200"><i className="ri-global-line"></i></span>
              <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-background-200"><i className="ri-movie-2-line"></i></span>
              <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-background-200"><i className="ri-video-line"></i></span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 美国式禁忌4 影视门户 · 本站所有影视及资讯内容均为虚构演示示例</p>
          <p>本站播放功能仅为前端演示，不提供任何真实影源与下载能力</p>
        </div>
      </div>
    </footer>
  );
}